/** @format */

export const AI_MONITORING_BANNER_STORAGE_KEY = 'ai_monitoring_banner_shown';
